import { render, staticRenderFns } from "./AIPopUp.vue?vue&type=template&id=644623a9&scoped=true"
import script from "./AIPopUp.vue?vue&type=script&lang=js"
export * from "./AIPopUp.vue?vue&type=script&lang=js"
import style0 from "./AIPopUp.vue?vue&type=style&index=0&id=644623a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644623a9",
  null
  
)

export default component.exports